import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

export const verifyCertificate = id => get(url.VERIFY_CERTIFICATE + id);


